// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"136":"css/328","170":"css/322","182":"css/326","252":"css/app","403":"css/330","432":"css/287","529":"css/329","575":"css/327","755":"css/323","807":"css/kangpro"}[chunkId] + ".css";
};